import { render, staticRenderFns } from "./orderingUnit.vue?vue&type=template&id=41b0735b"
import script from "./orderingUnit.vue?vue&type=script&lang=js"
export * from "./orderingUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports